import axios from 'axios';
export default {
	getFiles(language, day) {
		return axios.get('/apps/treasurykids/api/files', {
			params: {
				language,
				day
			}
		});
	}
};
